import leadsSearchFiltersI18nKeys from "./i18n";

/** @deprecated Use `leadsSearchFiltersI18nKeys.filter(field)` from `utils/i18n` instead. */
export const getFilterChipTranslationKey = (field: string): string => leadsSearchFiltersI18nKeys.filterChip(field);
